import _ from 'lodash';
export const handleErrors = (errors, orderType, action) => {
  const error = _.find(errors, (
    { property }
  ) => property === `instance.${orderType}.${action}`);

  return error || {};
};
